import { ParagraphText } from "../../../../Libraries";
import { Box } from "@mui/material";
import styles from "./styles.module.css";

const HeaderItem = ({ data }) => {
  const { I18n } = data || {};

  return (
    <Box className={styles.tableHeader}>
      <Box className={`${styles.col} ${styles.itemCol}`}>
        <Box className={styles.chevronPlaceholder} />
        <Box className={styles.checkboxPlaceholder} />
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.item}
        </ParagraphText>
      </Box>

      <Box className={`${styles.col} ${styles.skuCol}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.sku?.toUpperCase()}
        </ParagraphText>
      </Box>

      <Box className={`${styles.col} ${styles.categoryCol}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.category}
        </ParagraphText>
      </Box>

      <Box className={`${styles.col} ${styles.brandCol}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.brand}
        </ParagraphText>
      </Box>

      <Box className={`${styles.col} ${styles.statusCol}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          Stock status
        </ParagraphText>
      </Box>

      <Box className={`${styles.col} ${styles.visibilityCol}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          Visibility
        </ParagraphText>
      </Box>

      <Box className={`${styles.col} ${styles.priceCol}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.price}
        </ParagraphText>
      </Box>

      <Box className={`${styles.col} ${styles.actionsCol}`}>
        <ParagraphText className="fontSize12 fontWeight500 newLightColor">
          {I18n.actions}
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default HeaderItem;
